import axios from 'axios'

export default class {
  _documentStatisticsUrl
  _additionalConfig

  constructor() {
    this._documentStatisticsUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_STATISTICS_DOCS}`
    this._documentStatisticsYearsUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_STATISTICS_DOCS_YEARS}`
  }

  getDocumentStatistics(year) {
    const url = this._documentStatisticsUrl + '?anio=' + year
    return axios.get(url)
  }

  getYearsDocStatistics() {
    return axios.get(this._documentStatisticsYearsUrl)
  }
}
